export default "__VITE_ASSET__EKiOxhru__"